import React from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

// eslint-disable-next-line import/prefer-default-export
export const BatchFormActionsCellRenderer = ({
  value: id,
  data: batchForm,
  context: {
    settings,
    permissions,
    editCustomerLegalEntitiesCallback,
    getOriginalPdfFileCallback,
    editLinkedCustomerCallback,
    deleteFormCallback,
    batchItem
  }
}) => (
  <div className="form-action-btn-group">
    {((AccessControl.hasPermission(permissions,
      [ActivityPerms.scannedView,
        ActivityPerms.scannedEdit,
        ActivityPerms.scannedValidate])))
      && <FormViewButton
        permissions={ permissions }
        formId={ id }
        form={ batchForm }
        content={ <span className="icon icon-apps" /> }
        className="btn btn-sm"
        title="Reopen"
      /> }
    { (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
      ? AccessControl.hasPermission(permissions, [ActivityPerms.scannedView]) && <button
        type="button"
        title="View original PDF"
        rel="noopener noreferrer"
        className="btn btn-sm"
        onClick={ () => getOriginalPdfFileCallback(id) }
      >
        <span className="icon icon-photo" />
      </button>
      : AccessControl.hasPermission(permissions, [ActivityPerms.scannedView]) && <a
        href={ `/forms/${ batchForm.formType.toLowerCase() }/${ id }/pdf` }
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-sm"
        title="View original PDF"
      >
        <span className="icon icon-photo" />
      </a> }
    { settings && batchForm.customerId && batchForm.customerId !== ''
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
      && batchForm.formType
      && batchForm.formType.toLowerCase() !== 'unknown'
      && <span><button
        className="btn btn-sm "
        onClick={ () => editCustomerLegalEntitiesCallback(batchForm) }
        type="button"
        title="Edit Legal Entity"
      >
        <span className="icon icon-edit" />
      </button></span> }
    { AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
      && <button
        className="btn btn-sm"
        onClick={ () => editLinkedCustomerCallback(batchForm) }
        type="button"
        title="Edit Linked Customer"
      >
        <span className="icon icon-people" />
      </button> }
    { batchItem
      && batchItem.statusString !== 'Completed'
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
      && <button
        className="btn btn-sm btn-danger"
        onClick={ () => deleteFormCallback(batchForm) }
        type="button"
        title="Delete form"
      >
        <span className="icon icon-delete" />
      </button> }
  </div>
);

BatchFormActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    formType: PropTypes.string,
    isOnlineForm: PropTypes.bool
  }).isRequired,
  context: PropTypes.shape({
    batchItem: PropTypes.shape({
      statusString: PropTypes.string
    }),
    permissions: PropTypes.arrayOf(PropTypes.string),
    editCustomerLegalEntitiesCallback: PropTypes.func,
    getOriginalPdfFileCallback: PropTypes.func,
    editLinkedCustomerCallback: PropTypes.func,
    deleteFormCallback: PropTypes.func,
    settings: PropTypes.shape()
  })
};

BatchFormActionsCellRenderer.defaultProps = {
  context: {}
};
